import React, { forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { useAblumDetailHooks } from '../../hooks/dataHooks';
import { translate } from '@shakkerai/util-i18n';
import { HistoryList } from '../HistoryList';

export const AblumDetail = forwardRef((props, ref) => {
  const { searchValueRef, sortValueRef, premiumAblumId, onDataUpdate } = props;

  const scrollContainerRef = useRef(null);

  const { data, loading, loadingMore, noMore, reload, loadTotal } = useAblumDetailHooks(
    scrollContainerRef,
    searchValueRef,
    sortValueRef,
    premiumAblumId,
  );

  useEffect(() => {
    if (premiumAblumId) {
      reload();
    }
    // eslint-disable-next-line
  }, [premiumAblumId]);

  useImperativeHandle(ref, () => ({
    refresh: () => {
      loadTotal();
    },
    reload: () => {
      reload();
    },
  }));

  useEffect(() => {
    onDataUpdate(data);
  }, [data, onDataUpdate]);

  return (
    <HistoryList
      searchValueRef={searchValueRef}
      scrollContainerRef={scrollContainerRef}
      noSearchStr={translate('no_search_result_album')}
      noDateStr={translate('history_album_placeholder')}
      source="album"
      deleteRefreshLabel="event_ablumDetail"
      newRecordEventLabel="event_ablumDetailOnNewRecords"
      data={data}
      loading={loading}
      loadingMore={loadingMore}
      noMore={noMore}
      reload={reload}
    />
  );
});
